import { useEffect, useRef } from "react";

export default function GoogleSignInButton({ clientId, onSuccess, disabled = false }) {
  const containerRef = useRef(null);

  useEffect(() => {
    if (!clientId || !containerRef.current || disabled) return undefined;

    let cancelled = false;

    const renderButton = () => {
      if (cancelled || !containerRef.current || !window.google?.accounts?.id) return;
      const width = Math.max(containerRef.current.offsetWidth || 0, 180);
      containerRef.current.innerHTML = "";
      window.google.accounts.id.initialize({
        client_id: clientId,
        callback: (response) => {
          if (response?.credential) onSuccess?.(response.credential);
        },
      });
      window.google.accounts.id.renderButton(containerRef.current, {
        type: "standard",
        theme: "outline",
        size: "large",
        text: "continue_with",
        shape: "rectangular",
        logo_alignment: "left",
        width,
      });
    };

    if (window.google?.accounts?.id) {
      renderButton();
      return () => {
        cancelled = true;
      };
    }

    const existing = document.querySelector('script[data-brixigo-gsi="true"]');
    const onLoad = () => renderButton();

    if (existing) {
      existing.addEventListener("load", onLoad);
      if (window.google?.accounts?.id) renderButton();
      return () => {
        cancelled = true;
        existing.removeEventListener("load", onLoad);
      };
    }

    const script = document.createElement("script");
    script.src = "https://accounts.google.com/gsi/client";
    script.async = true;
    script.defer = true;
    script.dataset.brixigoGsi = "true";
    script.onload = onLoad;
    document.head.appendChild(script);

    return () => {
      cancelled = true;
      script.onload = null;
    };
  }, [clientId, disabled, onSuccess]);

  if (!clientId) return null;

  return (
    <div
      ref={containerRef}
      className="bg-google-signin-slot"
      aria-hidden={disabled}
      style={{ opacity: disabled ? 0.6 : 1, pointerEvents: disabled ? "none" : "auto" }}
    />
  );
}
